<template>
  <b-modal
    :id="modalID"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    size="lg"
    :title="modalTitle"
  >
    <template #modal-header>
      <div class="w-100 d-flex justify-content-between align-items-center">
        <h4>{{ modalTitle }}</h4>
        <h4 v-if="nettoyage">
          <i
            class="mdi mdi-checkbox-blank-circle mr-1"
            :style="`color: ${nettoyage.statut.couleur}`"
          ></i>
          {{ nettoyage.statut.nom }}
        </h4>
      </div>
    </template>
    <template #default>
      <div v-if="nettoyage">
        <div class="mt-4 mb-4">
          <div
            class="row d-flex"
            :class="{
              'justify-content-center': nettoyage.statut.code === 1,
            }"
          >
            <div class="col-md-12 mt-1">
              <div class="table-rsesponsive" style="background: white">
                <table class="table table-detail">
                  <tbody>
                    <tr>
                      <td>
                        <span class="d-flex justify-content-between">
                          <span>
                            <i class="fa fa-building text-custom-primary"></i>
                            <span class="font-weight-bold"> Chantier</span>
                          </span>
                          <span>{{ nettoyage.chantier }}</span>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span class="d-flex justify-content-between">
                          <span>
                            <i class="fa fa-calendar text-custom-primary"></i>
                            <span class="font-weight-bold"> Date</span>
                          </span>
                          <span>{{ nettoyage.date }} </span>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span class="d-flex justify-content-between">
                          <span>
                            <i class="far fa-clock text-custom-primary"></i>
                            <span class="font-weight-bold"> Heure début</span>
                          </span>
                          <span>
                            {{ nettoyage.heure_debut }}
                          </span>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span class="d-flex justify-content-between">
                          <span>
                            <i class="far fa-clock text-custom-primary"></i>
                            <span class="font-weight-bold"> Heure fin</span>
                          </span>
                          <span>
                            {{ nettoyage.heure_fin }}
                          </span>
                        </span>
                      </td>
                    </tr>

                    <tr class="border">
                      <td colspan="2" class="pt-4">
                        <span>
                          <i
                            class="mdi mdi-comment-edit text-custom-primary"
                          ></i>
                          <span class="font-weight-bold"> Commentaire</span>
                        </span>
                        <div class="p-3">
                          {{ nettoyage.commentaire }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="bg-white col-md-5 mt-3 mb-4">
              <div class="table-rsesponsive">
                <h5 class="text-center">
                  <i class="fa fa-users mr-2 text-custom-primary"></i> Equipe
                  planifiée
                </h5>
                <ul v-if="nettoyage.equipe.length > 0" class="list-group">
                  <li
                    v-for="person in nettoyage.equipe"
                    :key="person.uuid"
                    class="list-group-item"
                  >
                    <a
                      style="cursor: pointer"
                      title="aperçu employé"
                      @click.prevent="
                        $router.push({
                          name: 'rh_employe-show',
                          params: { id: person.id },
                        })
                      "
                      ><i class="fa fa-user mr-2"></i>{{ person.nom }}
                      <i
                        v-if="nettoyage.statut.code === 1 && isAbsent(person)"
                        class="mdi mdi-circle-slice-8 text-danger ml-2"
                      ></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="nettoyage.statut.code === 1" class="col-md-1"></div>
            <div
              v-if="nettoyage.statut.code === 1"
              class="bg-white col-md-5 mt-3 mb-4"
            >
              <h5 class="text-center">
                <i class="fa fa-users mr-2 text-custom-primary"></i> Equipe de
                réalisation
              </h5>
              <ul v-if="nettoyage.equipe_reelle.length > 0" class="list-group">
                <li
                  v-for="person in nettoyage.equipe_reelle"
                  :key="person.uuid"
                  class="list-group-item"
                >
                  <a
                    style="cursor: pointer"
                    title="aperçu employé"
                    @click.prevent="
                      $router.push({
                        name: 'rh_employe-show',
                        params: { id: person.id },
                      })
                    "
                    ><i class="fa fa-user mr-2"></i>{{ person.nom }}</a
                  >
                  <i
                    v-if="isNew(person)"
                    class="mdi mdi-circle-slice-8 text-custom-primary ml-2"
                  ></i>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <button type="button" class="btn btn-danger mr-2" @click="hideModal">
        Fermer
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    nettoyage: {
      type: Object,
      required: true,
    },
    modalID: {
      type: String,
      required: true,
    },
    modalTitle: {
      type: String,
      required: true,
    },
  },

  methods: {
    /**
     * Modal note
     */
    isNew(emp) {
      return !this.nettoyage.equipe.some((e) => e.uuid === emp.uuid);
    },
    isAbsent(emp) {
      return !this.nettoyage.equipe_reelle.some((e) => e.uuid === emp.uuid);
    },

    hideModal() {
      this.$bvModal.hide(this.modalID);
      this.$emit('closeModal');
    },
  },
};
</script>

<style scoped></style>
